export default __webpack_public_path__ + "static/media/progressbar_4.ec586dab.PNG";